export default defineNuxtPlugin(
    getRoutingPlugin((pageName) => (() => import((`@/pages-dynamic/${pageName}.vue`))))
)
